/**
 * @generated SignedSource<<ad15fcd60a898fb5f8da7c1293945a09>>
 * @relayHash 8f178f632eb52a31c30a19a1eba85d2d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f9f22d148e47809e20b4dee6fe181b1331a8c5617512b553498f6ed2c329a4fa

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { VirtualAgentSettingsPageQuery } from './VirtualAgentSettingsPageQuery.graphql';

import newSettingsPage_provider from '@atlassian/jira-relay-provider/src/jsm-va-enable-ai-answers-page.relayprovider';
import checkForAiEnabledFF_provider from '@atlassian/jira-relay-provider/src/jsm-va-is-require-ai-enabled.relayprovider';
import vaStatusHeaderEnabled_provider from '@atlassian/jira-relay-provider/src/jsm-va-status-header.relayprovider';

const node: PreloadableConcreteRequest<VirtualAgentSettingsPageQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "f9f22d148e47809e20b4dee6fe181b1331a8c5617512b553498f6ed2c329a4fa",
    "metadata": {},
    "name": "VirtualAgentSettingsPageQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaenableaianswerspagerelayprovider": newSettingsPage_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvastatusheaderrelayprovider": vaStatusHeaderEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider": checkForAiEnabledFF_provider
    }
  }
};

export default node;
